import type { Network } from '@vaultsfyi/common/types'

export const CROSSCHAIN_PROVIDER = 'rhinestone'

export const CROSSCHAIN_SUPPORTED_NETWORKS: ReadonlyArray<Network> = ['mainnet', 'base', 'optimism', 'arbitrum']
